// Moved to api-types/sellingPlans.ts so apiTypes.ts can use the union without a
// circular import; re-exported here for existing consumers.
export { isApiSellingPlanFixedAmountPriceAdjustment, isApiSellingPlanFixedPriceAdjustment, isApiSellingPlanPercentagePriceAdjustment, } from '../api-types/sellingPlans.js';
export const CART_SOURCE_KEY = 'bcai_cart_source';
export const CART_SOURCE_FRONT_END = 'CLIENT';
export const CART_SOURCE_BACKEND = 'BACKEND';
